module.exports = {"520113100":"艳山红镇","520113101":"麦架镇","520113102":"沙文镇","520113200":"都拉布依族乡","520113201":"牛场布依族乡","520113400":"红云社区服务中心","520113401":"大山洞社区服务中心","520113402":"艳山红社区服务中心","520113403":"铝兴社区服务中心","520113404":"白沙关社区服务中心","520113405":"都新社区服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520113.json
// module id = 2265
// module chunks = 0